<ng-container>
  <div id="switch_question">
    @switch (question.QuestionType.trim().toLowerCase()) { @case ('radiobutton')
    {
    <div>
      <app-permit-radiobutton
        [question]="question"
        [hasContentError]="hasContentError"
      ></app-permit-radiobutton>
    </div>
    } @case ('multiplechoice') {
    <div>
      <app-permit-multiple-choice
        [question]="question"
        [hasContentError]="hasContentError"
      ></app-permit-multiple-choice>
    </div>
    } @case ('signature') {
    <div>
      <app-permit-signature
        [question]="question"
        [hasContentError]="hasContentError"
      ></app-permit-signature>
    </div>
    } @case ('label') {
    <div><app-permit-label [question]="question"></app-permit-label></div>
    } @case ('text') {
    <div>
      <app-permit-text-box
        [question]="question"
        [hasContentError]="hasContentError"
      ></app-permit-text-box>
    </div>
    } @case ('separator') {
    <div>
      <app-permit-separator [question]="question"></app-permit-separator>
    </div>
    } @case ('group') {
    <div>
      <app-permit-group
        [question]="question"
        [hasContentError]="hasContentError"
      ></app-permit-group>
    </div>
    } @case ('currentdate') {
    <div>
      <app-permit-currentdate [question]="question"></app-permit-currentdate>
    </div>
    } @case ('currenttime') {
    <div>
      <app-permit-currenttime [question]="question"></app-permit-currenttime>
    </div>
    } @default {
    <div>
      {{ question.Caption }} - {{ question.QuestionType }} - Not implemented
    </div>
    } }
  </div>
  @if (question.Divider) {
  <div class="divider"></div>
  }
</ng-container>
